import * as React from 'react';
import {connect} from "react-redux";
import classnames from "classnames";
import PropTypes from "prop-types";
import {Col, Input, Row, CardBody, Tooltip, InputGroupAddon, InputGroupText} from "reactstrap";
import {injectIntl} from "react-intl";
import InputMask from "react-input-mask";
import InputGroup from "reactstrap/es/InputGroup";

function IconInput(props) {
	const {disabled, isError, onChange, value, classes, icon, placeholder} = props

	const [touched, setTouched] = React.useState(false);

	const isValid = () => {
		return touched && !isError && value && !disabled;
	}

	return (
		<InputGroup className={
			classnames({
				'valid': isValid(),
				'error': isError,
				'icon-input': true
			}) + " " + classes
		}>
			<InputGroupAddon addonType={"prepend"} className={
				classnames({
					'valid': isValid(),
					'error': isError
				})
			}>
				{icon}
			</InputGroupAddon>
			<InputMask
				inputmode={"email"}
				type="text"
				placeholder={placeholder}
				onFocus={e => {
					e.target.select();
				}}
				onBlur={() => {
					if (value) {
						setTouched(true)
					}
				}}
				className={
					classnames({
						'valid': isValid()
					})
				}
				onChange={onChange}
				value={value}
			/>
		</InputGroup>
	);
}

IconInput.propTypes = {
	disabled: PropTypes.any,
	isError: PropTypes.any.isRequired,
	onChange: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
	classes: PropTypes.any.isRequired,
	icon: PropTypes.any.isRequired,
	placeholder: PropTypes.any.isRequired
};

function mapStateToProps(state) {
	return {}
}

export default connect(mapStateToProps, {})(injectIntl(IconInput));